import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FacultyService } from '../faculty.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormControl } from '@angular/forms';
import { map, Observable, of, startWith } from 'rxjs';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-dialog-filter',
  templateUrl: './dialog-filter.component.html',
  styleUrls: ['./dialog-filter.component.scss']
})
export class DialogFilterComponent implements OnInit {
  selectedLos: any;
  selectedState: any;
  selectedCity: any;
  selectedCampus: any;

  losOptions!: Observable<any[]>;
  stateOptions!: Observable<any[]>;
  cityOptions!: Observable<any[]>;
  campusOptions!: Observable<any[]>;

  losFilter: FormControl = new FormControl("");
  stateFilter: FormControl = new FormControl("");
  cityFilter: FormControl = new FormControl("");
  campusFilter: FormControl = new FormControl("");

  losDetails: any;
  customDate: any;
  stateDetails: any;
  losName: any;
  cityDetails: any;
  campusId: any;
  campusDetails: any;

  constructor(private spinner: NgxSpinnerService, @Inject(MAT_DIALOG_DATA) public data: any, private matdialofRef: MatDialogRef<DialogFilterComponent>, private service: FacultyService, private toast: ToastmessageService) { }
  ngOnInit(): void {
    console.log('DATE', this.data);
    this.customDate = this.data;
    this.getEmployeeAllowedLos();
  }


  getEmployeeAllowedLos() {
    this.spinner.show();
    this.service.getLosTableData(this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        console.log(res)
        this.losDetails = res;
        this.losOptions = this.losFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.losDetails, 'los'))
        ) || of([]);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
        console.log(err)
      }
    });
  }

  private Filter(value: string, list: any[], name: any): any[] {
    const searchValue = value.trim().toLocaleLowerCase();
    let filteredList = list.filter((item: any) => item[name] && item[name].toString().trim().toLocaleLowerCase().includes(searchValue));
    // console.log(filteredList)
    return filteredList;
  }

  getEmployeeAllowedState(item: any) {
    this.losName = item.los;
    this.spinner.show();
    this.clearState();
    this.service.getStateTableData(this.losName, this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.stateDetails = res;
        this.stateOptions = this.stateFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.stateDetails, 'stateName'))
        ) || of([]);
        this.spinner.hide();

      },
      error: (err: any) => {
        this.spinner.hide();
        console.log(err)
      }
    })
  }

  getEmployeeAllowedCity(item: any) {
    this.spinner.show();
    this.clearCity();
    this.service.getCityTableData(this.losName, item.stateId, this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.cityDetails = res;
        this.cityOptions = this.cityFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.cityDetails, 'cityName'))
        ) || of([]);
        this.spinner.hide();

      },
      error: (err: any) => {
        this.spinner.hide();
        console.log(err)
      }
    })
  }

  getEmployeeAllowedCampus(item: any) {
    this.spinner.show();
    this.clearCampus();
    this.service.getCampusTableData(item.cityId, this.customDate).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.campusDetails = res;
        this.campusOptions = this.campusFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.campusDetails, 'campusName'))
        ) || of([]);
        this.spinner.hide();

      },
      error: (err: any) => {
        this.spinner.hide();
        console.log(err)
      }
    })
  }

  getEmployeeAllowedbuilding(item: any) {
    this.campusId = item.campusId
    console.log('this.campusId', this.campusId);
  }

  clearState() {
    this.selectedState = null;
    this.stateFilter.patchValue('');
    this.clearCity();
  }
  clearCity() {
    this.selectedCity = null;
    this.cityFilter.patchValue('');
    this.clearCampus();
  }
  clearCampus() {
    this.selectedCampus = null;
    this.campusFilter.patchValue('');
  }

  closeDilaog(search: any) {
    if (!this.selectedLos) {
      this.toast.showWarning('Please select Los  to search');
      return;
    }
    else if (!this.selectedState) {
      this.toast.showWarning('Please select State  to search');
       return;
    }
    else if (!this.selectedCity) {
      this.toast.showWarning('Please select City  to search');
       return;
    }
    else if (!this.selectedCampus) {
      this.toast.showWarning('Please select Campus to search');
       return;
    }
    this.matdialofRef.close(this.campusId);
  }

  close() {
    this.matdialofRef.close();
  }

}
